// extracted by mini-css-extract-plugin
export default {"colorPickerPopover":"color_colorPickerPopover__-gHw6","colorPicker":"color_colorPicker__Xsn3-"};